<template>

  <div v-if="tcktQueueLs && GET_SIGNIN_RES" class="table-wrapper" >
    <div >
      <div class="table-header">
        <h3 class="d-flex align-items-center mb-8px">{{$t('dashBoard.cDPminiTkt.upcomingTicketingDeadlines')}}</h3>
        <button v-if="tcktQueueLs.length!=0" @click="navigateToTcktQueue()" class="litblue-custom">
          <span>{{$t('dashBoard.cDPminiTkt.viewAll')}}</span>
        </button>
      </div>
      <div class="table-wrap">
        <cTable
                :items="tQComputedList"
                :fields="ticketingQueueField"
                :fullScreen="false"
                hover
                :sorter="true"
                pagination
                class="table table-striped table-hover"
                @row-clicked="getTicketingOrderDetails"
        >
          <template #no-items-view>
            
            <!-- <div class="text-center my-5"> -->
              <h3>{{$t('dashBoard.cDPminiTkt.noItemsView')}}</h3>
            <!-- </div> -->
          </template>
          <template #orderId="{item}">
            <td >
              <div v-if="item.orderId">
                <div>{{ item.orderId }}</div>
              </div>
              <div v-if="item.FlightDetails">
                            <div v-for="(flight,index) in item.FlightDetails" :key="'f'+index">
                            
                            <span v-if="flight.pnr">{{flight.pnr}}</span>
                            <span v-else>{{ " - " }}</span>
                            </div>
              </div>
            </td>
          </template>
          <template #passengername="{item}">
            <td >
              <div v-if="item.passengername">
                <div>{{ item.passengername }}</div>
              </div>
              <span>{{ getPassengerCount(item) }}</span>



              <!-- <div v-else>{{ " - " }}</div> -->
            </td>
          </template>
          <template #airline="{item}">
            <td>
              <div v-if="item.airline">
                <strong>{{ item.airline }}</strong>
              </div>

              <div v-else>{{ " - " }}</div>
            </td>
          </template>
          <template #departure="{item}">
            <td>
              <div v-if="item.departure">
                <strong>{{ item.departure }}</strong>
              </div>

              <div v-else>{{ " - " }}</div>
            </td>
          </template>
          <template #arrival="{item}">
            <td>
              <div v-if="item.arrival">
                <strong>{{ item.arrival }}</strong>
              </div>

              <div v-else>{{ " - " }}</div>
            </td>
          </template>

          <template #journeytype="{item}">
            <td>
              <div class="d-flex">
                <div v-if="item.FlightDetails">
                  <div v-if="item.journeytype== 1||item.journeytype== 2">
                                        
               <div v-if="item.FlightDetails[0].departure && item.FlightDetails[0].arrival">
                                                <strong class="c-lit-black">{{item.FlightDetails[0].departure + ' - ' +
                                                    item.FlightDetails[0].arrival}}</strong>
                                            </div>
                                            
                                        </div>
                                        <div v-else-if="item.journeytype== 3">
                                            <div v-for="(flight,index) in item.FlightDetails" :key="index">
                      <div v-if="flight.departure && flight.arrival">
                                                <strong class="c-lit-black">{{flight.departure + ' - ' +
                                                    flight.arrival}}</strong>
                                            </div>
                                            </div>
                                            
                                        </div>
                </div>
                
              </div>


              <span>
                <span v-if="item.journeytype == 1">{{ $t('ticketingQueue.oneWay')}}</span>
                <span v-else-if="item.journeytype == 2">{{ $t('ticketingQueue.roundTrip') }}</span>
                <span v-else-if="item.journeytype == 3">{{ $t('ticketingQueue.multiCity') }}</span>
                <span  v-else>{{ " - " }}</span>
              </span>

              <!-- </div> -->
            </td>
          </template>

          <template #departuredate="{item}">
            <td>
              <div v-if="item.FlightDetails">
                                         <div v-if="item.journeytype == 2">
                                              <div
                                                    v-if="item.FlightDetails[0].departuredate"
                                            >{{item.FlightDetails[0].departuredate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                            </div>
                                            <div
                                                    v-if="item.FlightDetails[0].returndate"
                                            >{{item.FlightDetails[0].returndate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                            </div>
                                        </div>
                                        <div v-else-if="item.journeytype == 1">
                                            <div
                                                    v-if="item.FlightDetails[0].departuredate"
                                            >{{item.FlightDetails[0].departuredate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                            </div>
                                          
                                        </div>
                                         <div v-else-if="item.journeytype == 3">
                                            <div v-for="(flight,index) in item.FlightDetails" :key="index"
                                               
                                            >{{flight.departuredate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}
                                            </div>
                                            
                                        </div>
              </div>
              
            </td>
          </template>
<!--          <template #returndate="{item}">-->
<!--            <td>-->
<!--              <div v-if="item.returndate">{{item.returndate | formatDate(DATE_TIME_FORMAT.DATE_TIME_MINS)}}</div>-->
<!--              <div v-else>{{ " - " }}</div>-->
<!--            </td>-->
<!--          </template>-->
          <template #pnr="{item}">
            <td >
              <div v-if="item.pnr">{{item.pnr}}</div>
              <div v-else>{{ " - " }}</div>
            </td>
          </template>
          <template #ticketingdeadline="{item}">
            <td>
<!--              <div-->
<!--                      v-if="item.ticketingdeadline"-->
<!--              >{{item.ticketingdeadline | formatDateTime(DATE_TIME_FORMAT.DATE_TIME_MINS) }}</div>-->
              <div
                      v-if="item.ticketingdeadline"
              >{{item.ticketingdeadline | timeLeftFormat}} </div>
              <div v-else>{{ " - " }}</div>
            </td>
          </template>
          <template #currency="{item}">
            <td class="py-2 d-flex align-center amount">
              <div v-if="item.currency">
                <strong>{{ item.currency }}</strong>
              </div>
              <div v-if="item.amount">{{ item.amount | formatNumber(item.currency)}}</div>
            </td>
          </template>
          <template #username="{item}">
            <td class="py-2">

<!--              <div v-if="item.username">{{ item.username}}</div>-->
              <div  v-if="item.username">{{ $t('ticketingQueue.view')}}</div>
            </td>
          </template>
          <template #bookingStatus="{item}">
            <td class="py-2">
              <div class="t-body">
                <div class="content-wrap">
                  <div class="t-wrap">
                    <div :class="'indicate-dot'+ ' '+ getStatusClass(item)">
                      <div></div>
                    </div>
                    <span :class="'indicate-dot-text ' +' '+getStatusClass(item)">
                          <span v-if=" getStatusClass(item) == 'paid'">{{$t('dashBoard.cDPminiTkt.ticketedSuccess')}}</span>
                      <span v-if=" getStatusClass(item) == 'unpaid'&&item.status==11">{{$t('dashBoard.cDPminiTkt.ticketingPending')}}</span>
                      <span v-if=" getStatusClass(item) == 'partial_paid'">{{$t('dashBoard.cDPminiTkt.hold')}}</span>
                      <span v-if=" getStatusClass(item) == 'unpaid'&&item.status==15">{{$t('dashBoard.cDPminiTkt.bookingCancelled')}}</span>
                      <span v-if=" getStatusClass(item) == 'unpaid'&&item.status==8">{{$t('dashBoard.cDPminiTkt.paymentStatusPending')}}</span>
                        </span>
                  </div>
                </div>
              </div>
            </td>
          </template>

          <!-- </div> -->
        </cTable>


      </div>
    </div>


  </div>

</template>
<script>
import Logger from "../../services/logger";
import { VALIDATE_SUCCESS_RES, getErrorMessage } from "@/util/apiValidate.js";
import router, { navigate, goBack } from "../../router/index";
import apiGetMiniTcktQueueLs from "./../../services/apiGetMiniTcktQueueLs";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import { COMPONENT_NAME, PATHNAME, BOOKING_STATUS,DATE_TIME_FORMAT } from "../../util/constants";
import BaseConfiguration from "../../config/base.js";
import SERVICE_URL from "../../config/API_DATA";
import { mapGetters, mapActions } from "vuex";
import { handleJWT, getErrorAlertValue } from "../../util/util";
import cTable from "../../components/dataTable/cTable";

export default {
  name: COMPONENT_NAME.C_DP_MINITCKT,
  components:{
    cTable
  },
  data: () => {
    return {
      tcktQueueLs: [],
      ticketingQueueField: []
    };
  },


   computed:{
     ///only for table items for sorting purpose(nested keys)
       tQComputedList () {
      let retValue=[];
     this.tcktQueueLs.forEach(item => {
            if (item && item.FlightDetails){
               
                item.departuredate=[];
                 item.departure=[];
                item.FlightDetails
                  .map(flight => {
                 
                     if (flight.departure) {
                    item.departure.push(flight.departure);
                     }
                      if (flight.departuredate) {
                    item.departuredate.push(flight.departuredate);
                      }
                      
                  })


                  retValue.push(item)
            }
          });
          return retValue;

  },
       DATE_TIME_FORMAT()
          {
            return DATE_TIME_FORMAT
          },
 ...mapGetters('sAgtLogin',{GET_SIGNIN_RES:'GET_SIGNIN_RES'})            
        
   },

  async created() {
    if (BaseConfiguration.isDebug) console.log("created");
    try {
       if(this.GET_SIGNIN_RES  ) {
         let tcktQueue = await this.getMiniTcktingQueueLs();
         if(tcktQueue&&tcktQueue.list){
        this.tcktQueueLs = tcktQueue.list;
         }
    
      this.ticketingQueueField = this.getDataField();
       }
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.C_DP_MINITCKT,
        "error in  Created",
        err.toString(),
        " Created()",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },

  methods: {
     ...mapActions("sTicketingQueue", {
     SET_TICK_QUEUE_REQ: "SET_TICK_QUEUE_REQ"
    }),
    showAlert(val) {
      this.$emit("showAlert", val);
    },
    getTicketingOrderDetails(ptcktObj){
//       let tcktObj ={
//         FlightDetails: [{
//         airline: null,
//         arrival: null,
//         departure: null,
//         departuredate: null,
//         pnr: null,
//         returndate: null,
//         ticketnumbers: null,
//         flight_number: null
//     }
// ], ticketingdeadline: null,
//  adultscount: 0,
//  agencyname: null, 
//  amount: null, 
//  b2bid: null, 
//  childcount: 0, 
//  contactmail: null,
//  contactnumber: null, 
//  currency: null,
//  infantcount: 0, 
//  journeytype: 0,
//  orderId: null,
//  passengername: null, 
//  status: 0,
//  username: null, 
//  bookingDate: null, 
//  bookingStatus: null
// }

// tcktObj.FlightDetails[0].airline = ptcktObj.airline;
// tcktObj.FlightDetails[0].arrival = ptcktObj.arrival;
// tcktObj.FlightDetails[0].departure = ptcktObj.departure;
// tcktObj.FlightDetails[0].departuredate = ptcktObj.departuredate;
// tcktObj.FlightDetails[0].pnr = ptcktObj.pnr;
// tcktObj.FlightDetails[0].returndate = ptcktObj.returndate;
// tcktObj.FlightDetails[0].ticketnumbers = null;
// tcktObj.FlightDetails[0].flight_number = null;
// tcktObj.ticketingdeadline = ptcktObj.ticketingdeadline;
// tcktObj.adultscount = ptcktObj.adultscount;
// tcktObj.agencyname = null;
// tcktObj.amount = ptcktObj.amount;
// tcktObj.b2bid = null;
// tcktObj.childcount = ptcktObj.childcount;
// tcktObj.contactmail = null;
// tcktObj.contactnumber = null;
// tcktObj.currency = ptcktObj.currency;
// tcktObj.infantcount = ptcktObj.infantcount;
// tcktObj.journeytype = ptcktObj.journeytype;
// tcktObj.orderId = ptcktObj.orderid;
// tcktObj.passengername = ptcktObj.passengername;
// tcktObj.status = ptcktObj.status;
// tcktObj.username = ptcktObj.username;
// tcktObj.bookingDate = null;
// tcktObj.bookingStatus = ptcktObj.bookingStatus;

                if(ptcktObj){
                   
                    this.SET_TICK_QUEUE_REQ(ptcktObj);
                   
                    // navigate(PATHNAME.TICKETING_QUEUE_DETAIL);
                    navigate(PATHNAME.BOOKING_DETAILS);
                    
                }
            },
    getPassengerCount(pPax) {
      try {
        if (BaseConfiguration.isDebug) console.log("getPassengerCount");
        //let retValue;
        let paxCount = 0;
        if (pPax) {
          if (pPax.adultscount)
            paxCount = paxCount + pPax.adultscount;
          if (pPax.childcount)
            paxCount = paxCount + pPax.childcount;
          if (pPax.infantcount)
            paxCount = paxCount + pPax.infantcount
        }
        if (paxCount > 1)
          paxCount = paxCount + ' '+this.$t('dashBoard.cDPminiTkt.passengers');
        else
          paxCount = paxCount + ' '+this.$t('dashBoard.cDPminiTkt.passenger');
        return paxCount;

      } catch (err) {
        let body = Logger.buildRequest(
                COMPONENT_NAME.C_DP_MINITCKT,
                "error in getPassengerCount",
                err.toString(),
                "getPassengerCount",
                LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    navigateToTcktQueue() {
        try {
          if(BaseConfiguration.isDebug) console.log("navigateToTcktQueue");
         navigate(PATHNAME.TICKETING_QUEUE);
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_DP_MINITCKT,
                  "error in navigateToTcktQueue",
                  err.toString(),
                  "navigateToTcktQueue",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
    }, 

    getDataField() {
      if (BaseConfiguration.isDebug) console.log("getDataField");
      return [

        {
          key: "bookingStatus",
          label: this.$t('dashBoard.cDPminiTkt.status'),
          sorter: false
        },
        {
          key: "orderId",
          label: this.$t('dashBoard.cDPminiTkt.id')
        },

        {
          key: "passengername",
          label: this.$t('dashBoard.cDPminiTkt.passengersLabel')
        },
        // {
        //   key: "airline",
        //   label: this.$t("ticketingQueue.airline")
        // },
        // {
        //   key: "departure",
        //   label: "departure"
        // },
        // {
        //   key: "arrival",
        //   label: this.$t("ticketingQueue.arrival")
        // },
        {
          key: "journeytype",
          label: this.$t('dashBoard.cDPminiTkt.route')
        },
        {
          key: "departuredate",
          label: this.$t("dashBoard.cDPminiTkt.travelDate")
        },
        // {
        //   key: "returndate",
        //   label: "returndate"
        // },
        // {
        //   key: "pnr",
        //   label: this.$t("ticketingQueue.pnr")
        // },
        {
          key: "ticketingdeadline",
          // label: this.$t("ticketingQueue.deadLine")
          label: this.$t("dashBoard.cDPminiTkt.deadline")
        },
        // {
        //   key: "currency",
        //   label: this.$t("ticketingQueue.amount")
        // },
        {
          key: "username",
          // label: this.$t("ticketingQueue.bookedBy")
          label:this.$t("dashBoard.cDPminiTkt.action"),
          sorter: false
        }
      ];
    },

    getStatusClass(pStatus) {
      try {
        if (BaseConfiguration.isDebug) console.log("getStatusClass");
        let retValue;
        if (pStatus.status == BOOKING_STATUS.HOLD_STATUS) {
                            retValue = 'partial_paid'
                        } else if (pStatus.status == BOOKING_STATUS.TICKETED_SUCCESS_STATUS) {
                            retValue = 'paid'
                        } else if (pStatus.status == BOOKING_STATUS.TICKET_PENDING) {
                            retValue = 'unpaid'
                        }else if (pStatus.status == BOOKING_STATUS.BOOKING_CANCELLED) {
                            retValue = 'unpaid'
                        
                        }else if (pStatus.status == BOOKING_STATUS.PAYMENT_STATUS_PENDING) {
                            retValue = 'unpaid'
                        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_DP_MINITCKT,
          "error in getStatusClass",
          err.toString(),
          "getStatusClass",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    async getMiniTcktingQueueLs() {
      if (BaseConfiguration.isDebug) console.log("getMiniTcktingQueueLs");
      let returnValue;
      try {
        let getMiniTcktingQueueLsReq = apiGetMiniTcktQueueLs.buildRequest(); //constant
        
        if (getMiniTcktingQueueLsReq != null) {
          let getMiniTcktingQueueLsRes = await apiGetMiniTcktQueueLs.getResponse(
            getMiniTcktingQueueLsReq
          );
         
          if (VALIDATE_SUCCESS_RES(getMiniTcktingQueueLsRes)) {
            returnValue = getMiniTcktingQueueLsRes.data.data;
                        

          } else {
            let error = getErrorMessage(getMiniTcktingQueueLsRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.showAlert(getErrorAlertValue(error));
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_DP_MINITCKT,
          "error in  getMiniTcktingQueueLs",
          err.toString(),
          "getMiniTcktingQueueLs()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    }
  }
};
</script>